module.exports = __webpack_public_path__ + "img/label4.10567b3b.png";